module.exports = __webpack_public_path__ + "assets/img/northerns-cricket-union.d3f19016.jpg";